/* eslint-disable */
/* Автогенерация: npm start / npm run build → scripts/write-app-version.cjs */
export const CLIENT_BUILD_ID = "mpy7u08g-b1b64f75372b11a1";
export const CLIENT_APP_VERSION = "1.0.1";
